import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SummaryHeaderAnalyticsMetric = ({
  dataTestId,
  title,
  count
}) => /*#__PURE__*/_jsxs(Flex, {
  "data-test-id": dataTestId,
  alignItems: "center",
  flexDirection: "column",
  flexGrow: "0",
  marginInlineEnd: "1000",
  children: [/*#__PURE__*/_jsx(Text, {
    as: "small",
    typography: "heading-25",
    marginBlockEnd: "100",
    children: title
  }), /*#__PURE__*/_jsx(Text, {
    as: "h2",
    children: count || 0
  })]
});
export default SummaryHeaderAnalyticsMetric;